import { Form, Radio } from 'antd';
import { useTranslation } from 'react-i18next';

import { MessageWrapper, StepWrapper } from '../../../styles';
import { ExamGroupsWarning } from '../../ExamGroupsWarning';
import { TranslatedText, TranslatedTitle } from '../components';

import { DescriptionText, SubjectToValidateWrapper } from './DefineYourGoalFP.styles';

import { ExamGroupSelector } from '@/components/Form/ExamGroupSelector';
import { Box } from '@/components/Utils';
import { RULES } from '@/constants';
import { useOnboardingFormLogic } from '@/hooks';

export const DefineYourGoalFP = () => {
  const { setExamGroupDate } = useOnboardingFormLogic();
  const { t } = useTranslation('StudentOnboardingPageTranslations');

  const form = Form.useFormInstance();
  // TODO: check if this is correct @Pedro
  const hasSubjectsToValidate = Form.useWatch(['userInfo', 'hasSubjectsToValidate'], form);

  return (
    <StepWrapper>
      <TranslatedTitle i18nKey="DEFINE_YOUR_GOAL" />
      <Box flexDirection="column">
        <Box flexDirection="column" gap={12}>
          <TranslatedText i18nKey="WHAT_EXAM_GROUP_ARE_YOU_INTERESTED_IN" />
          <Form.Item name={['userInfo', 'examGroups']} style={{ marginBottom: 0 }}>
            <ExamGroupSelector mode="multiple" onExamGroupSelect={setExamGroupDate} />
          </Form.Item>
          <ExamGroupsWarning />
        </Box>
        <SubjectToValidateWrapper>
          <Box flexDirection="column" gap={2}>
            <TranslatedText i18nKey="SUBJECTS_TO_VALIDATE" />
            <DescriptionText>{t('SUBJECTS_TO_VALIDATE_DESCRIPTION')}</DescriptionText>
          </Box>
          <Form.Item name={['userInfo', 'hasSubjectsToValidate']} rules={[RULES.REQUIRED]}>
            <Radio.Group style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <Radio value={true}>
                <TranslatedText i18nKey={`YES`} />
              </Radio>
              <Radio value={false}>
                <TranslatedText i18nKey={`NO`} />
              </Radio>
            </Radio.Group>
          </Form.Item>
          {hasSubjectsToValidate && (
            <MessageWrapper>
              <TranslatedText i18nKey="SUBJECTS_TO_VALIDATE_MESSAGE" />
            </MessageWrapper>
          )}
        </SubjectToValidateWrapper>
      </Box>
    </StepWrapper>
  );
};
